import React from "react";
import Card from "components/card";
import { MdOutlineLocalOffer, MdOutlineDiscount } from "react-icons/md";

// Helper function to format date
const formatDate = (date) => {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(date).toLocaleDateString("en-GB", options);
};

// Helper function to check if coupon is expired
const isCouponExpired = (expires) => {
  return new Date(expires) < new Date();
};

function YourTransfers({ appliedCoupons = [] }) {
  // Filter for expired and active coupons
  const expiredCoupons = appliedCoupons.filter((coupon) => !coupon.isActive || isCouponExpired(coupon.expires));
  const activeCoupons = appliedCoupons.filter((coupon) => coupon.isActive && !isCouponExpired(coupon.expires));

  return (
    <Card extra="px-9 w-full h-full pt-[28px] pb-4 flex flex-col justify-between">
      <h4 className="mb-8 mt-3 text-lg font-bold text-navy-700 dark:text-white flex items-center gap-2">
        <MdOutlineLocalOffer className="text-brand-500" />
        Applied Coupons
      </h4>

      <div className={`${expiredCoupons.length === 0 && activeCoupons.length === 0 ? "flex flex-grow items-center justify-center" : ""}`}>
        {expiredCoupons.length === 0 && activeCoupons.length === 0 ? (
          <div className="text-center">
            <MdOutlineDiscount className="text-4xl text-gray-400 mx-auto mb-3" />
            <p className="text-gray-500 dark:text-gray-400 mb-2">
              No coupons available.
            </p>
            <p className="text-xs text-gray-400 dark:text-gray-500">
              Your referral codes and coupons will appear here.
            </p>
          </div>
        ) : (
          <>
            {/* Active Coupons Section */}
            {activeCoupons.length > 0 && (
              <div className="mb-6">
                <h5 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-3">Active Coupons</h5>
                {activeCoupons.map((coupon, index) => (
                  <div key={index} className="flex justify-between items-center mb-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
                    <div>
                      <p className="font-semibold text-navy-700 dark:text-white flex items-center gap-2">
                        <MdOutlineDiscount className="text-green-600" />
                        {coupon.title}
                      </p>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        Expires: {formatDate(coupon.expires)}
                      </p>
                    </div>
                    <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm font-medium border border-green-400">
                      Active
                    </span>
                  </div>
                ))}
              </div>
            )}

            {/* Expired Coupons Section */}
            {expiredCoupons.length > 0 && (
              <div>
                <h5 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-3">Expired Coupons</h5>
                {expiredCoupons.map((coupon, index) => (
                  <div key={index} className="flex justify-between items-center mb-4 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div>
                      <p className="font-semibold text-navy-700 dark:text-white flex items-center gap-2">
                        <MdOutlineDiscount className="text-gray-400" />
                        {coupon.title}
                      </p>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        Expired: {formatDate(coupon.expires)}
                      </p>
                    </div>
                    <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-medium border border-red-400">
                      Expired
                    </span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>

      <div className="ml-auto mt-[42px] mb-[10px] flex w-max items-center gap-1">
        <div className="text-base font-bold text-brand-500 transition-all hover:-translate-x-1 hover:cursor-pointer dark:text-white">
          See all coupons
        </div>
      </div>
    </Card>
  );
}

export default YourTransfers;
